import { Component, OnInit } from '@angular/core';
import { ApiService } from "app/services/api.service";
import { FormGroup, FormBuilder } from "@angular/forms";
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';


@Component({
  selector: 'app-checkin',
  providers: [],
  templateUrl: './checkin.component.html',
  styleUrls: ['./checkin.component.css'],
})

export class CheckinComponent implements OnInit {

  public searchUserForm: FormGroup;
  public users: any[];
  public apiUrl:any;

  public isCheckingIn: boolean = false;
  public showLoadingSpinner: boolean = true;

  public showCheckinSpinner: boolean = false;

  constructor(private apiService: ApiService, private formBuilder: FormBuilder, private _sanitizer: DomSanitizer) {
    this.searchUserForm = this.formBuilder.group({
      searchUser: ['']
    });

    this.searchUserForm.valueChanges.subscribe(data => {
      for (let i = 0; i < this.users.length; i++) {
        if(this.users[i].userName.toLowerCase().search(data.searchUser.toLowerCase()) != -1) {
          this.users[i].matchesSearch = 'match';
        } else {
          this.users[i].matchesSearch = 'no-match';
        }
      }
    });
  }

  ngOnInit() {
    this.getUsers();
    this.apiUrl = this.apiService.getApiUrl();
    window.scrollTo(0,0);
  }

  // Get all active users
  getUsers() {
    var today = new Date();
    today.setHours(0,0,0,0);
    
    this.apiService.get('users?active=true&latestVisit[$lt]='+today+'&[$sort]=-createdAt').then((response:any) => {
      this.users = response.data;
      this.showLoadingSpinner = false;
    }).catch((err) => {
    });
  }

  // Get sanitzed background url
  getBackgroundImage(image) {
    return this._sanitizer.bypassSecurityTrustStyle('url(' + image + ')');
  }

  // Get sanitzed avatar url
  getAvatarBackgroundImage(image) {
    return this._sanitizer.bypassSecurityTrustStyle('url(' + this.apiUrl + 'avatar/' + image + '.png)');
  }

  // Sign in user
  signInUser(user) {
    if(this.isCheckingIn) {
      return;
    }

    this.showCheckinSpinner = true;
    this.isCheckingIn = true;
    this.apiService.post('visits',{"userId":user._id}).then((response:any) => {
      user.animationState = 'void';
      setTimeout(() => {
        this.isCheckingIn = false;
        user.checkedIn = true;
        this.searchUserForm.controls['searchUser'].setValue('');
        this.showCheckinSpinner = false;
      }, 1000)
    }).catch((err) => {
      console.log(err);
      this.isCheckingIn = false;
      this.showCheckinSpinner = false;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/checkin/checkin.component.ts